<script setup lang="ts">
import type { LillopointsItem } from "@/schemas/lillopoints";

const { cart } = useCart();

const { myLillopoints, isLoading, status, error } = useMyLillopoints();
const columns: TableColumn<LillopointsItem>[] = [
  { key: "timestamp", label: "Date", width: "128px", mobileFullWidth: true, verticalAlign: "middle" },
  { key: "description", label: "Description", verticalAlign: "middle" },
  { key: "order_id", label: "Commande", width: "128px", verticalAlign: "middle" },
  { key: "points", label: "Points", horizontalAlign: "right" },
];
</script>

<template>
  <UiDefaultPage title="Lillopoints">
    <div class="flex flex-col gap-8 lg:flex-row">
      <div class="flex flex-1 flex-col gap-8">
        <UiSidebarCard title="Vos Lillopoints">
          <template #picto>
            <SvgPictoLillopoints />
          </template>
          <div class="flex flex-col items-center">
            <div class="text-4xl font-bold text-primary">
              {{ integer(cart.lillopoints.total_points) }}
            </div>
            <div class="text-lg font-medium text-muted">
              (Une valeur de {{ currency(cart.lillopoints.total_points / cart.lillopoints.conversion_rate) }})
            </div>
          </div>
        </UiSidebarCard>
      </div>
      <div class="lg:flex-[0_0_75%]">
        <UiQueryWrapper :is-loading="isLoading" :status="status" :error="error">
          <UiEmptyResult v-if="!myLillopoints.items.length" title="Aucun Lillopoint" />
          <UiResponsiveTable v-else :columns="columns" :data="myLillopoints.items">
            <template #timestamp-cell="{ row }">
              {{ date(row.timestamp) }}
            </template>
            <template #order_id-cell="{ row }">
              <OrderLink :order-id="row.order_id" />
            </template>
            <template #points-cell="{ row }">
              <div class="">
                <div class="text-2xl font-bold text-primary">
                  {{ pluralize(row.points, "point", "points") }}
                </div>
                <div class="text-sm text-muted">
                  {{ pluralize(row.total, "point", "points") }}
                </div>
              </div>
            </template>
          </UiResponsiveTable>
        </UiQueryWrapper>
      </div>
    </div>
  </UiDefaultPage>
</template>
